import React from 'react'
import { MyBrainProvider } from './Brain'

export const wrapRootElement = ({ element }) => (
    <MyBrainProvider>{element}</MyBrainProvider>
)

//below code is needed for page transitions to work
export const shouldUpdateScroll = () => {
    return false;
};


export const onInitialClientRender = () => {
    const WIDGET_SELECTOR = '#netlify-identity-widget';

    let frameInUse = null;     // the one “good” iframe
    let modalWatcher = null;     // MutationObserver that watches aria-hidden

    /** Toggles the iframe’s display whenever the modal’s aria-hidden changes */
    const attachModalObserver = (frame) => {
        if (!frame) return;

        // Same‑origin?  If the widget later navigates cross‑origin this will fail,
        // but the content is still 'about:blank' when it is first injected.
        let innerDoc;
        try {
            innerDoc = frame.contentDocument || frame.contentWindow.document;
        } catch {
            return;   // can’t peek inside – see fallback further down
        }

        const modal = innerDoc.querySelector('.modalContainer');
        if (!modal) {
            // widget not fully rendered yet – try again shortly
            setTimeout(() => attachModalObserver(frame), 50);
            return;
        }

        // keep iframe hidden until we know the modal is open
        const sync = () => {
            const hidden = modal.getAttribute('aria-hidden') === 'true';
            frame.style.display = hidden ? 'none' : 'block';
        };

        sync();  // run once right now

        modalWatcher = new MutationObserver(sync);
        modalWatcher.observe(modal, {
            attributes: true,
            attributeFilter: ['aria-hidden'],
        });
    };

    /** Removes any duplicate identity iframes, keeps the newest, and sets up observers */
    const tidyIframes = () => {
        const frames = Array.from(document.querySelectorAll(WIDGET_SELECTOR));
        if (frames.length === 0) return;

        const keeper = frames[frames.length - 1]; // newest iframe

        frames.forEach((f) => {
            if (f !== keeper && f.parentNode) f.parentNode.removeChild(f);
        });

        // If the keeper has changed, reset our observers
        if (keeper !== frameInUse) {
            if (modalWatcher) modalWatcher.disconnect();
            frameInUse = keeper;
            attachModalObserver(keeper);
        }
    };

    /**************
     *  INITIALISE
     **************/
    tidyIframes();                        // clean up anything already on the page

    // Watch the whole document for future iframes being added
    const docWatcher = new MutationObserver(tidyIframes);
    docWatcher.observe(document.body, { childList: true, subtree: true });

    /**************************************
     *  Fallback: widget’s own JS events  *
     **************************************/
    if (typeof window.netlifyIdentity !== 'undefined') {
        window.netlifyIdentity.on('open', tidyIframes); // ensure only one iframe
        window.netlifyIdentity.on('open', () => frameInUse && (frameInUse.style.display = 'block'));
        window.netlifyIdentity.on('close', () => frameInUse && (frameInUse.style.display = 'none'));
    }
};